var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import * as _ from "lodash";
import "../models/index.js";
import Logger from "@ane/core/lib/services/logging/Logger";
import { compareIgnoreCase } from "@ane/core/lib/utils/CommonStringUtils";
import AuthContext from "@ane/core/lib/services/MSALAuthService/MSALAuthService";
import { ApprovalEntityType } from "../models/expapi/FeatureApiModel.js";
import { OperationCheckTypes } from "../models/OperationCheckModels.js";
import { ProgressionType } from "../models/FeatureDataModel.js";
class FlightingApprovalUtils {
  constructor() {
    __publicField(this, "ApprovalType_O365Substrate", "O365SubstrateApprovalGate");
    __publicField(this, "ApprovalResolutionType", "Approval");
    __publicField(this, "experimentId", "ExperimentId");
    __publicField(this, "conflictingExperimentIds", "ConflictingExperimentIds");
    __publicField(this, "getWorkloadEnumValue", (workload) => {
      if (compareIgnoreCase(workload, "Griffin")) {
        return 1;
      }
      return 0;
    });
  }
  isO365SubstrateApprovalGate(gateName) {
    return compareIgnoreCase(this.ApprovalType_O365Substrate, gateName);
  }
  isApprovalGateByType(gateType) {
    if (!gateType)
      return false;
    return !!gateType.resolutionMetadata && !!gateType.resolutionMetadata.resolutionType && !!compareIgnoreCase(gateType.resolutionMetadata.resolutionType, this.ApprovalResolutionType);
  }
  validateExpBatchRequest(requests) {
    if (_.some(requests, (r) => !!r.Gate && this.isO365SubstrateApprovalGate(r.Gate.gateType.name))) {
      return `Batch submission of ${this.ApprovalType_O365Substrate} requests is not supported.`;
    } else if (_.some(requests, (r) => r.EntityType === ApprovalEntityType.progression)) {
      return "Batch submission of progression-level requests is not supported.";
    }
    return null;
  }
  convertToExpMultiStageRequest(requests, metadata) {
    const approvalStages = _.map(requests, (r) => this.getApprovalStageMetadata(r));
    const gateIds = _.map(requests, (r) => r.Gate.id);
    const multiStageRequest = {
      ResolutionMetadata: {
        Comment: metadata.comment,
        GateIds: gateIds
      },
      ApprovalStages: approvalStages
    };
    return multiStageRequest;
  }
  getApprovalStageMetadata(request) {
    const nextOperations = !_.isNull(request.OperationType) && !_.isUndefined(request.OperationType) ? [OperationCheckTypes[request.OperationType]] : [];
    const approvalStage = {
      ProgressionStageId: request.EntityId,
      NextOperations: nextOperations
    };
    return approvalStage;
  }
  convertToO365RequestParameters(request, metadata, alias, flightControl) {
    const { FlightAssignmentService, ApprovalServiceMetadata } = flightControl;
    const gateParams = {
      FeatureId: request.FeatureId,
      EntityId: this.getO365ApprovalEntityId(request),
      // @ts-ignore
      StageId: request.EntityType === ApprovalEntityType.progressionStage ? request.EntityId : null,
      // @ts-ignore
      StageName: request.EntityType === ApprovalEntityType.progressionStage ? request.EntityName : null,
      IsIncident: metadata.isIncident,
      ByPassPolicyCheck: metadata.byPassPolicyCheck,
      RequestorAlias: alias,
      RequestType: this.getO365ApprovalRequestType(request),
      // TODO - revisit, OperationType is optional
      OperationType: OperationCheckTypes[request.OperationType],
      acquireToken: (resource) => {
        return AuthContext.getToken({
          tokenScope: `${resource}/.default`
        });
      },
      log: (msg) => {
        Logger.info(msg);
      },
      /**
       * TODO: need to figure out the enum issue with EXO library (Same issue as line 130)
       * export declare enum ECSEnvironment {
       *     INT = 0,
       *     PROD = 1,
       *     DEV1 = 2,
       * }
       */
      ECSEnvironment: FlightAssignmentService === "ECS_Int" ? 0 : FlightAssignmentService === "ECS" ? 1 : 2,
      ManagementGroup: request.ManagementGroup,
      Subscriptions: request.Subscriptions,
      Workload: !!(ApprovalServiceMetadata == null ? void 0 : ApprovalServiceMetadata["Workload"]) ? this.getWorkloadEnumValue(ApprovalServiceMetadata["Workload"]) : void 0,
      AllowExperimentationPolicy: request.ProgressionType === ProgressionType.ABnProgression,
      // @ts-ignore
      AutoStartExperimentIds: metadata.autoStart && !!request.AutoStartCandidateExperimentId ? [request.AutoStartCandidateExperimentId] : null
    };
    return gateParams;
  }
  convertFromO365Response(response) {
    const isSuccessful = response.Status === 0;
    return {
      Succeeded: isSuccessful,
      Title: response.Message && response.Message.Title || "",
      Message: response.Message && response.Message.Content || ""
    };
  }
  convertFromExpResponse(response) {
    const isSuccessful = response.isSuccessful();
    const title = isSuccessful ? "Approval request submitted successfully" : "Approval request submission failed";
    const message = isSuccessful ? response.getSuccessData().StatusMessage : `Failed to submit approval request (Status: ${response.statusCode}-${response.statusText} CorrelationId: ${response.correlationId})`;
    return {
      Succeeded: isSuccessful,
      Title: title,
      Message: message
    };
  }
  convertFromOperationInfo(response) {
    if (!response.isSuccessful()) {
      return {
        Succeeded: true
      };
    } else {
      const succeeded = !response.getSuccessData().IsDisabled;
      const disabledItems = response.getSuccessData().DisabledInfo.Items;
      return {
        Succeeded: succeeded,
        Message: disabledItems
      };
    }
  }
  getMetadataForm(schema) {
    const form = {};
    Object.keys(schema).forEach((k) => {
      const item = schema[k];
      switch (item.type) {
        case "Boolean":
          form[k] = false;
          break;
        case "String":
          form[k] = "";
          break;
        case "Number":
          form[k] = 0;
          break;
        default:
      }
    });
    return form;
  }
  getO365ApprovalEntityId(request) {
    switch (request.EntityType) {
      case ApprovalEntityType.progressionStage:
        return request.ProgressionId;
      case ApprovalEntityType.progressionStep:
        throw new Error(`O365 approval currently doesn't support progression step level request.`);
      default:
        return request.EntityId;
    }
  }
  getO365ApprovalRequestType(request) {
    switch (request.EntityType) {
      case ApprovalEntityType.progression:
      case ApprovalEntityType.progressionStage:
        return 0;
      case ApprovalEntityType.override:
        return 1;
      case ApprovalEntityType.emergencyOverride:
        return 2;
      default:
        throw new Error(
          `Cannot resolve approval request type. The mapping for the approval entity type ${ApprovalEntityType[request.EntityType]} is missing.`
        );
    }
  }
  getAllProgressionStagePairs(progressionGroups) {
    let stagePairs = {};
    _.map(progressionGroups, (groups) => {
      _.map(groups, (group) => {
        _.map(group.allProgressionStages, (stage) => {
          stagePairs[stage.id] = group.name + ": " + stage.friendlyName;
        });
      });
    });
    return stagePairs;
  }
  /*** This is part of validateTrafficFilter overlap logic
   * The data pattern in disabledItems {
   *    "ExperimentId": "0000" (Guid type)
   *    "ConflictingExperimentIds": "1111,2222,3333" (list of Guids)
   * }
   * Aim to replace the Guid id with progression stage name
   */
  replaceEntityIdwithEntityName(disabledItems, stagePairs) {
    let items = _.map(disabledItems, (disabledItem) => {
      if (disabledItem.Data) {
        let conflictMsgs = disabledItem.Data[this.conflictingExperimentIds].split(";");
        let conflictNames = _.map(conflictMsgs, (conflictMsg) => {
          let firstIndex = conflictMsg.lastIndexOf("(");
          let lastIndex = conflictMsg.lastIndexOf(")");
          if (firstIndex !== -1) {
            return stagePairs[conflictMsg.substring(firstIndex + 1, lastIndex)];
          } else {
            return stagePairs[conflictMsg];
          }
        });
        return {
          Data: {
            ExperimentId: stagePairs[disabledItem.Data[this.experimentId]],
            ConflictingExperimentIds: conflictNames.join(" and ")
          },
          InfoLevel: disabledItem.InfoLevel
        };
      }
    });
    return items;
  }
}
const flightingApprovalUtils = new FlightingApprovalUtils();
export {
  FlightingApprovalUtils,
  flightingApprovalUtils
};
//# sourceMappingURL=FlightingApprovalUtils.js.map
